import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
const $= window.$;

class BookChat extends Component {
	constructor(props) {
		super(props);
        this.state={
        	call_date : props.events.call_date, 
        	chat_time_id : props.events.chat_time_id_pk,
        	id : props.events.id,
        	start : props.events.start,
        	end : props.events.end,
        	title : props.events.title1,
        	slots : props.events.slots,
        	cur_time : props.events.curr_time,
        	cur_date : props.events.curr_date,
        	date_call : props.events.date_call,
        	but_hide : 'none',
        	show : 'block',
        	hide : 'none',
        	preferred_time:'',
        	old_img : '',
        	preferred_id:''
        };

        this.showTimeslots = this.showTimeslots.bind(this);
        this.BookSlot = this.BookSlot.bind(this);
        this.Slot = this.Slot.bind(this);
       
	}

	showTimeslots(id){

	}

	Slot(time_chat_id){
		// alert(time_chat_id);
		let learner_id = Common.getUserData("id", true);
    	let pinid = Common.getUserData("pinID", true);
    	let pinno = Common.getUserData("pinNo", true);
		fetch(Config.domainUrl+'ecoach-chat/book-slot', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
			  'Authorization':'Bearer ' +Common.getTokenData()
            },

              body: JSON.stringify({
                learner_id:learner_id,pinid:pinid,pinno:pinno,chat_time_id:time_chat_id,
              })
            }).then((response) => response.json())
           .then((responseJson) => {
            if(responseJson.status != 0){
				Common.message("", responseJson.message, "success");
				this.props.closeModal();
				$("#sum").click();
            }
            else{
				Common.message(responseJson.message, responseJson.errors, "error");
            }
       });
	}

	BookSlot(time_id_chat,slot_time,id_img){
		let loc =process.env.PUBLIC_URL+"images/chat.gif";
		let old_loc = process.env.PUBLIC_URL+"images/chat_dull.gif";
		$('#'+id_img+' img').attr("src",loc);
		if(this.state.old_img!=''){
			$('#'+this.state.old_img+' img').attr("src",old_loc);
		}
		this.setState({
			but_hide : 'block',
			show : 'none',
			hide : 'block',
			preferred_time : slot_time,
			old_img : id_img,
			preferred_id : time_id_chat,
		})
	}


    componentWillReceiveProps(nextProps) {
	}


    componentDidMount() {
    	$(".accordion_coach").smk_Accordion();
    }




		render() {
			let slot_times = "";
			if(this.state.slots.length>0){
			 let d = 1;
			 slot_times = this.state.slots.map((slot,i)=>{
			 	let slots_seg = '';
			 	if(slot.length > 0){
			 		slots_seg = slot.map((sl,k)=>{
					 	let id_img = 'img'+d;
					 	d++;
			 			let style = '';
					 	let img = '';
					 	let slot_time = sl.start_slot+' to '+sl.end_slot;
					 	if(sl.slot_time_from < this.state.cur_time && this.state.date_call <= this.state.cur_date){
					 		img = '';
					 		style = 'line-through'; 
					 	}
					 	else if(sl.telecall_booking_status==1 || sl.chat_booking_status==1){
					 		img = <img src={process.env.PUBLIC_URL+"/images/chat_dull_tick.gif"} border="0"/>;
					 	}
					 	else if(this.state.chat_time_id_pk==sl.chat_time_slot_id_pk){
					 		img = <img src={process.env.PUBLIC_URL+"/images/chat.gif"} border="0"/>;
					 	}
					 	else{
					 		img = <img src={process.env.PUBLIC_URL+"/images/chat_dull.gif"} onClick={()=>this.BookSlot(sl.chat_time_slot_id_pk,slot_time,id_img)} border="0"/>;
					 	}
					 	return(
					 		[
							<td key={`sl_${k}`} className="chat-img" id={id_img}><div style={{width:'15px'}}>{img}</div></td>,
					 		<td key={`sltd_${k}`} style={{textDecoration:style,fontSize:'14px'}}>{sl.start_slot+' - '+sl.end_slot}</td>	 		
					 		]		
					 	)
			 		})
			 	}
			 	return(
			 		<tr key={`slots_${i}`}>
			 			{slots_seg}
			 		</tr>
			 	)
			 })
			}
			return (
				<div className="popup-ecoach">
					 <span ><h2 className="colorstyle">Schedule a one-on-one chat with your E Coach</h2></span><br/>
					 <h2 className="colorstyle">E Coach's available slots for chat on <a nohref='true' name="ptime">{this.state.call_date}</a></h2>
					<div className="timebg">
				        <h3>Preferred Time:<br/><span id="before_booking" style={{display:this.state.show}}>Click on the slots to choose your convenient time to have chat with your E Coach.</span><span id="booked_time_div" style={{display:this.state.hide}}>{this.state.preferred_time}</span></h3>
				        <div id="btndiv" className="button-cancel" style={{display:this.state.but_hide}}><a className="white" href="javascript:void(0);" onClick={()=>this.Slot(this.state.preferred_id)}>Book Slot</a></div>
				    </div>
				    <div className="telecal-popup accordion_coach">
					    <div className="tablescroll">
							<div className="accordion_in acc_active">
						     	<div className="acc_head"  onClick={this.showTimeslots(this.state.id)}>
									<div className="acc_icon_expand"></div>{this.state.title}
								</div>
								<div className="acc_content" style={{display: "block"}}>
									<table id={"trid_"+this.state.id} style={{display: 'block',borderCollapse: 'collapse',border: '1px solid rgb(231, 231, 231)', width: '100%', marginBottom: '10px'}} cellSpacing="1" cellPadding="1">
										<tbody>
											{slot_times}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		}
}

export default BookChat;



// WEBPACK FOOTER //
// ./src/personal_interactions/ecoach_request/BookChat.js